import React from 'react'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import Button from '../../button'
import Typography from '../../typography'

export const renderSlides = (panels: any, useCase: string, sliderTheme: string) => {
  if (!panels?.length) return null
  const slides = []
  const LOGO_QUOTE = 'Logo Quote'

  for (let i = 0; i < panels.length; i++) {
    const panelData = {
      author: {
        name: panels[i].authorName || '',
        title: panels[i].authorTitle || '',
      },
      company: panels[i].company || '',
      body: panels[i].body?.body || panels[i].body || '',
      cta: panels[i].quoteCta || panels[i].cta || {},
      image: {
        url: panels[i]?.image?.image?.file?.url || '',
        alt: panels[i]?.image?.altText || '',
        companyUrl: panels[i]?.companyLogo?.image?.file?.url || '',
        companyAlt: panels[i]?.companyLogo?.altText || '',
      },
    }

    slides.push(
      <div className="Quote__Slider-Item" key={`QuoteSlider-Item--${i}`}>
        {useCase === LOGO_QUOTE ? (
          <div className="Quote__Slider-Item-Inner">
            <div className="Quote__Slider-Item-Details">
              {panelData.body && (
                <Typography className="Quote__Body-Text" type="leadXS">
                  {panelData.body}
                </Typography>
              )}

              <div>
                <img
                  src={ImgUtil.getResizedImageUrl(panelData.image.companyUrl, 'width=252')}
                  alt={panelData.image.companyAlt}
                />

                <div>
                  {panelData.author.name && (
                    <Typography className="Quote__Author" type="header6">
                      {panelData.author.name}
                    </Typography>
                  )}

                  {panelData.author.title && panelData.company && (
                    <Typography
                      className="Quote__Title font__inter"
                      type="bodyXS">{`${panelData.author.title}, ${panelData.company}`}</Typography>
                  )}
                </div>
              </div>
            </div>

            <div className="Quote__Slider-Item-Image-Container">
              <img
                loading="lazy"
                src={ImgUtil.getResizedImageUrl(panelData.image.url, 'width=884')}
                alt={panelData.image.alt}
                key={`QuoteSlider-Image--${i}`}
              />
            </div>
          </div>
        ) : (
          <>
            {panelData.body && <Typography type="leadXS">{panelData.body}</Typography>}

            {panelData.author.name && (
              <Typography className="Quote__Author" type="label">
                {panelData.author.name}
              </Typography>
            )}

            {panelData.author.title && panelData.company && (
              <Typography
                className="Quote__Title font__inter"
                type="bodyXS">{`${panelData.author.title}, ${panelData.company}`}</Typography>
            )}

            {panelData.cta.text && panelData.cta.externalUrl && (
              <Button
                icon={true}
                href={
                  panelData.cta.internalLink
                    ? internalLinkHandler(panelData.cta.internalLink)
                    : panelData.cta.externalUrl
                }
                text={panelData.cta.text}
                type="text-link"
                size="small"
                className="Quote__CTA"
                theme={sliderTheme === 'Dark' ? 'dark' : 'light'}
              />
            )}
          </>
        )}
      </div>
    )
  }

  return slides
}
